import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDuubjNxnTw3BIOX3O-qZZioTfkrUXRpOU",
    authDomain: "trasker-app.firebaseapp.com",
    projectId: "trasker-app",
    storageBucket: "trasker-app.firebasestorage.app",
    messagingSenderId: "507840931738",
    appId: "1:507840931738:web:73953eebfc9318c9217c23",
    measurementId: "G-RQC7KVSZ6C"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
// Enforce LocalStorage Persistence for Extension compatibility
setPersistence(auth, browserLocalPersistence).catch((error) => {
    console.error("Firebase persistence error:", error);
});

export const db = getFirestore(app);
export const storage = getStorage(app);
// export const analytics = getAnalytics(app); 
